import {BACKEND_API} from '../middleware/backend'

export const WALKS_REQUEST = 'WALKS_REQUEST';
export const WALKS_SUCCESS = 'WALKS_SUCCESS';
export const WALKS_FAILURE = 'WALKS_FAILURE';
export const WALKS_COUNT_REQUEST = 'WALKS_COUNT_REQUEST';
export const WALKS_COUNT_SUCCESS = 'WALKS_COUNT_SUCCESS';
export const WALKS_COUNT_FAILURE = 'WALKS_COUNT_FAILURE';
export const WALK_REQUEST = 'WALK_REQUEST';
export const WALK_SUCCESS = 'WALK_SUCCESS';
export const WALK_FAILURE = 'WALK_FAILURE';
export const WALK_SAVE_REQUEST = 'WALK_SAVE_REQUEST';
export const WALK_SAVE_SUCCESS = 'WALK_SAVE_SUCCESS';
export const WALK_SAVE_FAILURE = 'WALK_SAVE_FAILURE';

export const WALK_UPDATE_STATUS_REQUEST = 'WALK_UPDATE_STATUS_REQUEST';
export const WALK_UPDATE_STATUS_SUCCESS = 'WALK_UPDATE_STATUS_SUCCESS';
export const WALK_UPDATE_STATUS_FAILURE = 'WALK_UPDATE_STATUS_FAILURE';

export const loadWalks = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [WALKS_REQUEST, WALKS_SUCCESS, WALKS_FAILURE],
			endpoint: "walk/list",
			filter: filter
		}
	})
};

export const countWalks = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [WALKS_COUNT_REQUEST, WALKS_COUNT_SUCCESS, WALKS_COUNT_FAILURE],
			endpoint: "walk/count",
			filter: filter
		}
	})
};

export const loadWalk = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [WALK_REQUEST, WALK_SUCCESS, WALK_FAILURE],
			endpoint: `walk/${id}`,
		}
	})
};

export const saveWalk = (walk) => (dispatch, getState) => {
	return dispatch({
		id: walk.walkId,
		walk: walk,
		[BACKEND_API]: {
			types: [WALK_SAVE_REQUEST, WALK_SAVE_SUCCESS, WALK_SAVE_FAILURE],
			endpoint: 'walk',
			body: walk,
			silent: true
		}
	})
};

export const updateWalkStatus = (status, walkIds) => (dispatch, getState) => {

	return dispatch({
		[BACKEND_API]: {
			types: [WALK_UPDATE_STATUS_REQUEST, WALK_UPDATE_STATUS_SUCCESS, WALK_UPDATE_STATUS_FAILURE],
			endpoint: `walk/update-status/${status}`,
			body: walkIds
		}
	})
}



// WEBPACK FOOTER //
// ./src/actions/walks.js